export default __webpack_public_path__ + "static/media/datapower-threat.3485a03b.svg";